export default __webpack_public_path__ + "static/media/g1.77d157ea.jpg";